import getParamsFromString from "../../Utils/getParamsFromString";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import request from "../../../../Services/API/Requests";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";

const PdfReader = (props) => {
    const {
        component,
        screenName, actionsContext
    } = props;
    const {styles: sourceStyles, properties: {source, content: contentSource} = {}} = component;
    const {globalValues: globalScreenValues} = useSelector(state => state.jsonScreen);
    const [pdfContent, setPdfContent] = useState("")
    const content = getParamsFromString(source, {...actionsContext, ...globalScreenValues}, screenName);

    useEffect(() => {
        content && getFile(content);
    }, [content])


    useEffect(() => {
        if(contentSource) {
            const content = getParamsFromString(contentSource, {...actionsContext, ...globalScreenValues}, screenName);
            console.log(content)
            if(content) {
                const source = content.split(',')[1]
                const blb = b64toBlob(source, 'application/pdf');
                const blobURL = window.URL.createObjectURL(blb);
                console.log(blobURL)
                setPdfContent(blobURL)
            }
        }
    }, [contentSource, JSON.stringify(globalScreenValues), JSON.stringify(actionsContext), screenName]);

    async function getFile(id) {
        try {
            const res = await request({
                url: "files/getFiles",
                data: {id}
            })
            const source = res.content.split(',')[1]
            const blb = b64toBlob(source, 'application/pdf');
            const blobURL = window.URL.createObjectURL(blb);
            setPdfContent(blobURL)
        } catch (e) {
            console.log('set file error', e)
        }
    }

    return (
        <div style={{width: '100%', height: '99.2%'}}>
            <iframe src={pdfContent} width={'100%'} height={'100%'}/>
        </div>
    )
}

export default JsonScreenHoc(PdfReader);

const b64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    // method which converts base64 to binary
    const byteCharacters = window.atob(content);

    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
        type: contentType
    }); // statement which creates the blob
    return blob;
};